import { cacheGetUUID } from '@/utils/cache.js'
import { Infoc, daohangMap } from '@shared/utils/infoc/index.js'

const reportClass = new Infoc(daohangMap, cacheGetUUID()) // 第二个参数是uuid，暂时用不上用sid替代

const commonParams = () => {
  const infoc = window?.app?.$store?.state.infoc || {}

  return {
    sid: 0,
    uid: 0,
    source: '',
    ver: 1,
    ext: '',
    ...infoc, // 上面是默认值
  }
}

export const report = (name, obj) => {
  const reportMap = {
    // dhsite_newpdf_load:242 sid:string pageload:int64 pagetype:int64 uid:int64 source:string ver:int64 ext:string
    load: () => reportClass.report({ ...commonParams(), business_index: 242, ...obj }),
  }

  reportMap[name]()
}
